module.exports = __webpack_public_path__ + "img/HERO-head-05-visalabot.47f999a1.png";